module.exports = __webpack_public_path__ + "static/media/a18.5142fbf9.jpg";